// @ts-nocheck

/**
 * * `PENDING` - Pending
 * `COMPOSITING` - Compositing Pages
 * `CONVERTING` - Converting to CMYK
 * `GENERATING` - Generating PDF
 * `UPLOADING` - Uploading to S3
 * `COMPLETE` - Complete
 * `ERROR` - Error
 */
export type Status0f9Enum = typeof Status0f9Enum[keyof typeof Status0f9Enum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const Status0f9Enum = {
  PENDING: "PENDING",
  COMPOSITING: "COMPOSITING",
  CONVERTING: "CONVERTING",
  GENERATING: "GENERATING",
  UPLOADING: "UPLOADING",
  COMPLETE: "COMPLETE",
  ERROR: "ERROR",
} as const;
